"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var cloneChildren = function (fn, children) {
    var childIndex = 0;
    var clonedChildren = react_1["default"].Children.map(children, function (child) {
        if (!react_1["default"].isValidElement(child)) {
            return null;
        }
        var idx = childIndex++;
        return react_1["default"].cloneElement(child, fn(idx, child.props));
    });
    return {
        count: childIndex,
        clonedChildren: clonedChildren
    };
};
exports["default"] = cloneChildren;
//# sourceMappingURL=cloneChildren.js.map